var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.highlightContainer,
    ( _obj = {}, _obj[_vm.$style.warning] = _vm.type === 'warning', _obj ),
    ( _obj$1 = {}, _obj$1[_vm.$style.danger] = _vm.type === 'danger', _obj$1 ) ],attrs:{"data-luko-tracking":"Highlight","data-aos":"zoom-in","data-aos-duration":"500"}},[_c('RichText',{attrs:{"text-params":_vm.primary.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }